import {EnumStavPrenosDtm} from '../api';

export const enumStavPrenosDtm: string[] = Object.keys(EnumStavPrenosDtm);

export const getEnumStavPrenosDtmCaption = (typ: string | EnumStavPrenosDtm): string => {
    switch (typ) {
        case EnumStavPrenosDtm.PRIPRAVENO:
            return 'Připraveno';
        case EnumStavPrenosDtm.PRIJATO:
            return 'Přijato';
        case EnumStavPrenosDtm.PROBIHA_ZPRACOVANI:
            return 'Probíhá zpracování';
        case EnumStavPrenosDtm.ZPRACOVANO:
            return 'Zpracováno';
        case EnumStavPrenosDtm.CHYBA:
            return 'Chyba';
        default:
            return `_${typ}`;
    }
};

type EnumStavPrenosDtmProps = {id: EnumStavPrenosDtm; name: string};

export const getEnumStavPrenosDtmItems = (): EnumStavPrenosDtmProps[] => {
    return enumStavPrenosDtm.map((t: EnumStavPrenosDtm): EnumStavPrenosDtmProps => ({id: t, name: getEnumStavPrenosDtmCaption(t)}));
};
